<template>
  <el-dialog title="详情"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-card shadow="none"
               class="bt-border4 mb-20">
        <div>
          <p class="card-text">
            <i class="el-icon-discount ftblue mr-10"></i>
            编号：{{ actData.code }}
          </p>
          <p class="card-text">
            <i class="el-icon-discount ftblue mr-10"></i>
            类型：{{ actData.type }}
          </p>
          <p class="card-text">
            <i class="el-icon-discount ftblue mr-10"></i>
            在线：{{ actData.status }}
          </p>
          <p class="card-text">
            <i class="el-icon-discount ftblue mr-10"></i>
            上线时间：{{ actData.time }}
          </p>
        </div>
      </el-card>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Number
    }
  },
  data() {
    return {
      showModal: this.isShow,
      actData: {
        code: '123',
        type: '123',
        status: '在线',
        time: '2020-09-09 10:00:00'
      }
    }
  },
  watch: {
    isShow(val) {
      this.showModal = val
    }
  },
  methods: {
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
